import { alpha } from '@mui/material';
import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  caseDetailsAI: {
    '.MuiStepContent-root': {
      marginLeft: theme.spacing(2),
      paddingRight: 0
    },
    '.MuiStepConnector-root': {
      marginLeft: theme.spacing(2)
    }
  },
  continuedAnalysisPaper: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    backgroundColor: alpha(theme.palette.primary.main, 0.2),
    borderColor: theme.palette.primary.main
  }
}));

export default useStyles;
